import { useEffect, useState } from 'react'
import { Button } from 'react-bootstrap'
import { fetchApi } from '@inmagik/react-crud'
import { Field, Formik, getIn } from 'formik'
import { Link, useParams } from 'react-router-dom'
import { API_URL } from '../constants'
import yup from '../utils/validations'

const schema = yup.object().shape({
  password: yup
    .string()
    .required('Password è un campo obbligatorio')
    .min(8, 'La password deve essere lunga almeno 8 caratteri.'),
  repeatPassword: yup
    .string()
    .required('Conferma Password è un campo obbligatorio')
    .oneOf([yup.ref('password'), ''], 'Le password non corrispondono.'),
})

const initialValues = {
  password: '',
  repeatPassword: '',
}

export function AttivazioneAccount() {
  const [confirm, setConfirm] = useState(false)
  const [isSubmitting, setIsSubmitting] = useState(false)
  const [error, setError] = useState<string | null>(null)
  const { token } = useParams()

  useEffect(() => {
    fetchApi(API_URL + '/utenti/users/check-activation-token/', {
      method: 'POST',
      body: JSON.stringify({
        token,
      }),

      headers: {
        'Content-Type': 'application/json',
      },
    })
      .then((e) => {
        console.log(e)
      })
      .catch((e) => {
        setError('Link di attivazione non valido o utente già attivato')
      })
  }, [token])

  return (
    <div className="d-flex h-100 bg-primary">
      <div className="w-50 bg-primary h-100 d-flex flex-column justify-content-center align-items-center">
        <img
          src="/statik/main/LOGO.svg"
          height={40}
          alt=""
          className="d-block mb-2 me-2"
          onError={(e) => {
            ;(e.target as HTMLImageElement).style.display = 'none'
          }}
        />
      </div>
      <div
        className="w-50 d-flex flex-column justify-content-center align-items-center bg-white"
        style={{
          borderRadius: '20px 0 0 20px',
        }}
      >
        <div className="w-50">
          <h1 className="heading-h1">ATTIVAZIONE ACCOUNT</h1>
          {!error && (
            <div className="p-medium">
              Seleziona una nuova password per attivare il tuo account.
            </div>
          )}
          {error && <div className="alert alert-danger mt-2 py-1">{error}</div>}
          {!error && (
            <Formik
              validationSchema={schema}
              initialValues={initialValues}
              enableReinitialize
              onSubmit={async (values) => {
                try {
                  setIsSubmitting(true)
                  await fetchApi(API_URL + '/utenti/users/activate_account/', {
                    method: 'POST',
                    body: JSON.stringify({
                      ...values,
                      token,
                    }),

                    headers: {
                      'Content-Type': 'application/json',
                    },
                  }).then((e) => {
                    setIsSubmitting(false)
                    setConfirm(true)
                  })
                } catch (e: any) {
                  setError("Errore durante l'attivazione dell'account")
                } finally {
                  setIsSubmitting(false)
                }
              }}
            >
              {({ handleSubmit, touched, errors }) => (
                <form onSubmit={handleSubmit}>
                  <div className="mt-2">
                    <div className="form-group">
                      <label
                        htmlFor="password"
                        className="label-m text-body-secondary"
                      >
                        Password
                      </label>
                      <Field
                        name="password"
                        type="password"
                        className={
                          'form-control' +
                          (getIn(errors, 'password') &&
                          getIn(touched, 'password')
                            ? ' is-invalid'
                            : '')
                        }
                      />
                      {getIn(errors, 'password') &&
                        getIn(touched, 'password') && (
                          <div className="text-danger">
                            {getIn(errors, 'password')}
                          </div>
                        )}
                    </div>
                    <div className="form-group mt-2">
                      <label
                        htmlFor="repeatPassword"
                        className="label-m text-body-secondary"
                      >
                        Conferma Password
                      </label>
                      <Field
                        name="repeatPassword"
                        type="password"
                        className={
                          'form-control' +
                          (getIn(errors, 'repeatPassword') &&
                          getIn(touched, 'repeatPassword')
                            ? ' is-invalid'
                            : '')
                        }
                      />
                      {getIn(errors, 'repeatPassword') &&
                        getIn(touched, 'repeatPassword') && (
                          <div className="text-danger">
                            {getIn(errors, 'repeatPassword')}
                          </div>
                        )}
                    </div>
                  </div>
                  <div>
                    {confirm && (
                      <div className="alert alert-success mt-2 py-1">
                        Account attivato con successo <br />
                        Procedi con il <Link to="/login">login</Link>
                      </div>
                    )}
                  </div>

                  <Button
                    type="submit"
                    variant="secondary"
                    className="w-100 mt-2 text-white"
                    disabled={isSubmitting}
                  >
                    Attiva account
                    {isSubmitting && (
                      <span className="spinner-border spinner-border-sm ms-2"></span>
                    )}
                  </Button>
                </form>
              )}
            </Formik>
          )}
        </div>
      </div>
    </div>
  )
}
